import "dayjs/locale/ja";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(localeData);
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.updateLocale(dayjs.locale(), {
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"],
});

export function formatPassTime(created_time?: string) {
  const pastTime = dayjs(created_time);
  const currentTime = dayjs();
  return pastTime.from(currentTime);
}

// 后端不同人开发的接口对请求参数或请求体中的时间格式要求不一样，这是 user monitor 接口的参数要求
export function dateISOfy(date: string) {
  return dayjs(date).format("YYYY-MM-DD") + "T00:00:00+09:00";
}

export function addOneDayAndDateISOfy(date: string) {
  return dayjs(date).add(1, "day").format("YYYY-MM-DD") + "T00:00:00+09:00";
}

export function updateDayjsLocale(lang: string) {
  switch (lang) {
    case "en":
      dayjs.updateLocale("en", { relativeTime: { ...relativeTime_EN } });
      break;
    case "zh":
      dayjs.updateLocale("zh", { relativeTime: { ...relativeTime_ZH } });
      break;
    case "ja":
      dayjs.updateLocale("ja", {
        relativeTime: { ...relativeTime_JA },
      });
      break;
    default:
      dayjs.updateLocale("ja", {
        relativeTime: { ...relativeTime_JA },
      });
  }
}

const relativeTime_JA = {
  past: "%s前",
  s: "1秒",
  m: "1分",
  mm: "%d分",
  h: "1時間",
  hh: "%d時間",
  d: "1日",
  dd: "%d日",
  M: "1月",
  MM: "%d月",
  y: "1年",
  yy: "%d年",
};
const relativeTime_ZH = {
  past: "%s前",
  s: "1秒",
  m: "1分",
  mm: "%d分",
  h: "1小时",
  hh: "%d小时",
  d: "1日",
  dd: "%d日",
  M: "1月",
  MM: "%d月",
  y: "1年",
  yy: "%d年",
};
const relativeTime_EN = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years",
};

export default dayjs;

export const dayjsTokyoTZ = (date: string | Date | undefined = undefined) => dayjs.utc(date).tz("Asia/Tokyo");
